import type { MediaType } from "@/types/media";

export const typeLabels: Record<MediaType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export function getTypeLabel(type: string): string {
  return typeLabels[type as MediaType] ?? "影视";
}